import ms from "ms";
import { makeHook } from "../../utils/makeSingleArgHook";
import getTask from "../requests/getTask";
import { taskUrl } from "../requests/urls";
const useGetTask = makeHook(getTask, (taskId) => [taskUrl("v4", taskId)], { staleTime: ms("5minutes") });
export default useGetTask;
//# sourceMappingURL=useGetTask.js.map